/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import * as React from 'react';

export interface IPaymentError {
    title: string;
    message: string;
}

const PaymentError: React.FC<IPaymentError> = ({ title, message }) => (
    <div className='ms-checkout-payment-instrument__error' role='alert' aria-live='assertive'>
        <p className='ms-checkout-payment-instrument__error-title'>
            {title}
        </p>
        <p className='ms-checkout-payment-instrument__error-message'>
            {message}
        </p>
    </div>
);

export default PaymentError;
